import React from 'react';
import PropTypes from 'prop-types';
import './index.less'
const Toggle = ({ style, isActive }) =>
    <div style={style} className={`toggle-box ${isActive ? 'on' : 'off'}`} />

Toggle.propTypes = {
    isActive: PropTypes.bool.isRequired,
    style: PropTypes.object
}
export default Toggle;


// WEBPACK FOOTER //
// ./src/components/common/Toggle/index.jsx